"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHashParam = void 0;
var react_1 = require("react");
var parseUrlParams_1 = __importDefault(require("../../helpers/parseUrlParams"));
var getHashParams = function () {
    return (0, parseUrlParams_1.default)(window.location.hash.replace(/^#/, ""));
};
var useHashParams = function (callback) {
    var onHashchange = (0, react_1.useCallback)(function () {
        if (callback) {
            callback(getHashParams());
        }
    }, [callback]);
    (0, react_1.useEffect)(function () {
        if (onHashchange) {
            window.addEventListener("hashchange", onHashchange);
            onHashchange();
        }
        return function () {
            if (onHashchange) {
                window.removeEventListener("hashchange", onHashchange);
            }
        };
    }, [onHashchange]);
    return getHashParams();
};
var useHashParam = function (name, callback) {
    return useHashParams(callback
        ? function (data) {
            callback(data[name]);
        }
        : undefined)[name];
};
exports.useHashParam = useHashParam;
exports.default = useHashParams;
